exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-message{margin:10px 0;background:#fffce3;border:2px solid #eed300;color:#c28e00;font-weight:700;font-size:1.166em;padding:10px;-moz-border-radius:6px;-webkit-border-radius:6px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/InfoMessage/InfoMessage.less
 ** module id = 1064
 ** module chunks = 0
 **/